import React, { useState } from "react";

import Confirm from "./Confirm";
import Notify from "./Notify";

interface UpdateStepProps {
  resourcesCount: number;
  affectedSubscriptionsCount: number;
  onConfirmUpdate: (notify: boolean) => Promise<void>;
  onCancelUpdate: () => void;
}

export default function ({
  resourcesCount,
  affectedSubscriptionsCount,
  onConfirmUpdate,
  onCancelUpdate,
}: UpdateStepProps): React.JSX.Element {
  const [step, setStep] = useState<"confirm" | "notify">("confirm");

  return (
    <React.Fragment>
      <Confirm
        isOpen={step === "confirm"}
        resourcesCount={resourcesCount}
        affectedSubscriptionsCount={affectedSubscriptionsCount}
        onCancelUpdate={onCancelUpdate}
        onNext={() => setStep("notify")}
      />
      <Notify
        isOpen={step === "notify"}
        onCancelUpdate={onCancelUpdate}
        onConfirmUpdate={onConfirmUpdate}
        onBack={() => setStep("confirm")}
      />
    </React.Fragment>
  );
}
